.container {
  flex: 2 1 75%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border-radius: var(--border-radius-medium);
  overflow-y: auto;
  background-color: var(--color-grayscale-eerie-black);
  gap: 2.4rem;

  @media screen and (min-width: $bp-small) {
    flex-direction: row;
    height: unset;
    padding: 1.6rem;
  }

  @media screen and (max-width: $bp-medium) {
    min-height: 100%;
  }
}

.empty-placeholder-wrapper {
  width: 100%;

  div {
    user-select: none;
    background-color: var(--color-grayscale-eerie-black);
    background-size: 36rem;
    max-width: unset;

    p {
      display: inline-block;
      font-weight: 500;
      font-size: 3.2rem;
      color: var(--color-grayscale-white);
    }
  }
}
